






















































































































































































import { ComponentGroup, HeatingSystem, formatMetricValue, TreeNode } from '@/util/modbus';
import { defineComponent, PropType } from '@vue/composition-api';
import { mapGetters } from 'vuex';
import { HeatingSystemCollectionWithPaginationQuery_heatingSystemsList_items } from '@/hsc-api/queries/__generated__/HeatingSystemCollectionWithPaginationQuery';
import { SpotQueryWithLatestMetrics } from '../../__generated__/SpotQueryWithLatestMetrics';
import GroupsMixin from '@/features/core/components/mixins/groups';
import {
  filterHeatingSystemsByType,
  HEATING_SYSTEM_COMPONENT_TYPE_FILTERS,
  HeatingSystemType,
} from '@/util/heating-systems';
import AdvancedViewGraphModal from '@/features/app-heating-system/views/tree-node/heating-systems-list/components/AdvancedViewGraphModal.vue';
import propertiesInDirectoryQuery from '@/features/app-heating-system/views/tree-node/get-properties-using-directory-id.gql';
import { DirectoryPropertiesQuery } from '../../__generated__/DirectoryPropertiesQuery';
import { Register } from '@/features/core/store/page-modules/modbus-edit-registers/modbus-edit-register.module';
import HeatingSystemSummaryModal from '@/features/app-heating-system/views/tree-node/heating-systems-list/HeatingSystemSummaryModal.vue';
import AlertTicketsByCustomerIdQuery from '@/hsc-api/queries/AlertTicketsByCustomerIdQuery.gql';
import { APOLLO_CLIENT } from '@/features/core/container/model';
import { TicketStatus } from '@/types/hsc-types';
import {
  PufferspeicherLabel,
  WarmwasseraufbereitungLabel,
  addPresentPufferLabels,
  addPresentWarmwasseraufbereitungLabels,
  getNeededPufferspeicherGroupNames,
  getNeededWarmwasseraufbereitungGroupNames,
  initPresentByGroupName,
  initPresentWarmwasserByGroupName,
  isPufferspeicher,
  isWarmwasseraufbereitung,
  metricNameForLabelPos,
  metricNameForPufferspeicherLabel,
  metricNameForWarmwasseraufbereitungLabel,
  pickMeasurementGroupForLabelPos,
  findPufferspeicherGroupByLabel,
  findWarmwasseraufbereitungGroupByLabel,
  resolveOrderedPufferspeicherLabels,
  resolveOrderedWarmwasseraufbereitungLabels,
} from '@/features/app-heating-system/util/group-labels';

interface TreeNodeHeatingSystem {
  treeNodeId: string;
  heatingSystems: HeatingSystem[];
}

interface componentAbbreviation extends ComponentGroup {
  abbreviation: string;
}

type SubColumn = {
  label: string;
};

type MeasurementRef = {
  measurementType?: string | null;
  metricName?: string | null;
};

type OtherComponentLabelPos = 'firstLabel' | 'secondLabel';

export default defineComponent({
  components: {
    AdvancedViewGraphModal,
    HeatingSystemSummaryModal,
  },
  mixins: [GroupsMixin],
  props: {
    treeNodes: {
      type: Array as PropType<TreeNode[]>,
      required: true,
    },
    directoryHeatingSystemMap: {
      type: Map as PropType<Map<string, HeatingSystem[]>>,
      required: true,
      default: () => new Map<string, HeatingSystem[]>(),
    },
    modbusMetricNames: {
      type: Array as PropType<string[]>,
      required: true,
    },
    columnNames: {
      type: Array as PropType<string[]>,
      required: true,
    },
    components: {
      type: Array as PropType<ComponentGroup[]>,
      required: true,
    },
    spots: {
      type: Array as PropType<SpotQueryWithLatestMetrics['spots']['items']>,
      required: true,
    },
    expandAllSignal: {
      type: Number,
      required: false,
      default: 0,
    },
    collapseAllSignal: {
      type: Number,
      required: false,
      default: 0,
    },
    heatingSystems: {
      type: Array as PropType<HeatingSystem[]>,
      required: true,
    },
    selectedHeatingSystemType: {
      type: String as PropType<HeatingSystemType | null>,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      selectedSpotId: null as string | null,
      selectedHeatingSystem: null as HeatingSystem | null,
      skip: 0,
      take: 500,
      nodes: [] as TreeNode[],
      treeNodeHeatingSystems: [] as TreeNodeHeatingSystem[],
      showContextMenu: false,
      contextMenuStyle: {
        top: '0px',
        left: '0px',
      },
      contextMenuHeatingSystem: null as HeatingSystem | null,
      directoryProperties: [] as string[],
      lastExpandSignal: 0,
      lastCollapseSignal: 0,
      showSummaryModal: false,
      summaryModalHeatingSystem: null as HeatingSystem | null,
      contextMenuOptions: [
        { label: 'Daten und Zeiträume', action: 'Daten und Zeiträume', icon: 'graph' },
        { label: 'Status', action: 'Status', icon: 'bell' },
        { label: 'Störungen', action: 'Störungen', icon: 'exclamation-triangle' },
        { label: 'Strangschema', action: 'Strangschema', icon: 'temperature-high' },
      ],
      summaryModalTab: '',
      contextMenuTreeNodeId: null as string | null,
      alertCounts: {} as Record<string, number>,
    };
  },
  computed: {
    noHeatingSystems(): boolean {
      return this.nodes.every((treeNode) => this.getHeatingSystems(treeNode).length === 0);
    },
    ...mapGetters({
      tableData: 'tableData',
      selectedCustomerId: 'selectedCustomerId',
    }),
    additionalColumns(): string[] {
      const draggedTableRegisters = this.tableData
        .filter((item: Register, index: number, self: Register[]) => {
          return index === self.findIndex((t) => t.registerName === item.registerName);
        })
        .map((item: Register) => {
          return item.registerName;
        });
      const uniqueTableRegisters = Array.from(new Set([...draggedTableRegisters, ...this.columnNames])).sort();
      return uniqueTableRegisters;
    },
    processedList(): componentAbbreviation[] {
      return this.components
        .map((item: ComponentGroup) => {
          const name = item.groupName.toLowerCase();
          const abbreviationMap: Record<string, string> = {
            kessel: 'K',
            mischer: 'M',
            'wärmetauscher primäre': 'WTP',
            'wärmetauscher sekundäre': 'WTS',
            'wärmepumpe primäre': 'WPP',
            'wärmepumpe sekundäre': 'WPS',
            bhkw: 'BHKW',
            'pufferspeicher sekundäre': 'PS',
            pufferspeicher: 'P',
            'fernwärme sekundärseite': 'FWS',
            fernwärme: 'FW',
            warmwasseraufbereitung: 'WW',
            außentemperatur: 'AT',
            solarthermieanlage: 'SL',
            heizkreis: 'HK',
            gaszähler: 'GAS',
            wärmemengenzähler: 'n/a',
            unbekanntegruppennamen: 'UG',
            warmwasserbereitung: 'WWB',
            heizungssteuerung: 'HS',
          };

          let abbreviation = 'UG';

          for (const key in abbreviationMap) {
            if (name.includes(key)) {
              abbreviation = abbreviationMap[key];
              break;
            }
          }

          // Check if name contains any number and add it to the abbreviation
          const compNum = name.match(/\d+/);
          if (compNum) {
            abbreviation += ` ${compNum}`;
          }

          return { ...item, abbreviation };
        })
        .sort((a, b) => {
          if (a.type === 'HEATING_CONTROL' && b.type !== 'HEATING_CONTROL') {
            return 1;
          }
          if (a.type !== 'HEATING_CONTROL' && b.type === 'HEATING_CONTROL') {
            return -1;
          }
          return 0;
        });
    },

    spotId(): string {
      const spotIds = this.selectedHeatingSystem?.heatingSystemMeasurementGroups[0].heatingSystemMeasurements.map(
        (m) => m.spotId,
      );
      return Array.from(new Set(spotIds))[0];
    },
    filteredTreeNodes(): TreeNode[] {
      const treeNodes = this.treeNodes.map((item) => ({
        ...item,
        isOpen: true,
      }));

      if (this.advancedViewSearchQuery) {
        const searchQuery = String(this.advancedViewSearchQuery).trim().toLocaleLowerCase();
        const searchQueryType = this.treeNodes.find((tn) => tn.name.toLocaleLowerCase().includes(searchQuery));
        if (searchQueryType?.__typename === 'Directory') {
          const matchingPropertiesTreeNodes = this.treeNodeHeatingSystems.filter((ths) =>
            ths.heatingSystems.some((hs) => hs.name.toLocaleLowerCase().includes(searchQuery)),
          );
          return treeNodes.filter(
            (treeNode) =>
              matchingPropertiesTreeNodes.find((tn) => tn.treeNodeId === treeNode.id) ||
              treeNode.name.toLocaleLowerCase().includes(searchQuery),
          );
        }
        return treeNodes.filter(
          (treeNode) =>
            treeNode.name.toLocaleLowerCase().includes(searchQuery) || this.getHeatingSystems(treeNode).length > 0,
        );
      }

      return treeNodes;
    },
    treeNodeIds(): string[] {
      return this.filteredTreeNodes.map((item) => item.id);
    },
    advancedViewSearchQuery(): string | null {
      return this.$store.getters.advancedViewSearchQuery;
    },
    filteredContextMenuOptions(): Array<{ label: string; action: string; icon: string }> {
      if (this.contextMenuHeatingSystem && this.isHeatingControl(this.contextMenuHeatingSystem)) {
        // Hide "Status" option if not WMbus device
        return this.contextMenuOptions.filter((opt) => opt.action !== 'Status');
      }
      return this.contextMenuOptions;
    },

    pufferspeicherLabelsByGroupName(): Record<string, PufferspeicherLabel[]> {
      const neededGroupNames = getNeededPufferspeicherGroupNames(this.components);
      if (neededGroupNames.size === 0) return {};

      const presentByGroupName = initPresentByGroupName(neededGroupNames);
      addPresentPufferLabels(presentByGroupName, neededGroupNames, this.heatingSystems);
      const result: Record<string, PufferspeicherLabel[]> = {};
      for (const groupName of neededGroupNames) {
        result[groupName] = resolveOrderedPufferspeicherLabels(presentByGroupName[groupName]);
      }
      return result;
    },
    warmwasseraufbereitungLabelsByGroupName(): Record<string, WarmwasseraufbereitungLabel[]> {
      const neededGroupNames = getNeededWarmwasseraufbereitungGroupNames(this.components);
      if (neededGroupNames.size === 0) return {};

      const presentByGroupName = initPresentWarmwasserByGroupName(neededGroupNames);
      addPresentWarmwasseraufbereitungLabels(presentByGroupName, neededGroupNames, this.heatingSystems);
      const result: Record<string, WarmwasseraufbereitungLabel[]> = {};
      for (const groupName of neededGroupNames) {
        result[groupName] = resolveOrderedWarmwasseraufbereitungLabels(presentByGroupName[groupName]);
      }
      return result;
    },
    subColumnsByGroupName(): Record<string, SubColumn[]> {
      const result: Record<string, SubColumn[]> = {};

      for (const component of this.components) {
        if (this.isPufferspeicher(component.groupName)) {
          const labels = this.pufferspeicherLabelsByGroupName[component.groupName] ?? ['VL', 'RL'];
          result[component.groupName] = labels.map((label) => ({ label }));
          continue;
        }
        if (this.isWarmwasseraufbereitung(component.groupName)) {
          const labels = this.warmwasseraufbereitungLabelsByGroupName[component.groupName] ?? ['W', 'Z'];
          result[component.groupName] = labels.map((label) => ({ label }));
          continue;
        }

        result[component.groupName] = [{ label: 'VL' }, { label: 'RL' }];
      }

      return result;
    },
  },
  watch: {
    expandAllSignal(newVal) {
      if (newVal !== this.lastExpandSignal) {
        this.filteredTreeNodes.forEach((node) => {
          node.isOpen = true;
        });
        this.lastExpandSignal = newVal;
      }
    },
    collapseAllSignal(newVal) {
      if (newVal !== this.lastCollapseSignal) {
        this.filteredTreeNodes.forEach((node) => {
          node.isOpen = false;
        });
        this.lastCollapseSignal = newVal;
      }
    },
    async advancedViewSearchQuery(value) {
      this.nodes = this.filteredTreeNodes;
      const directories = this.treeNodes
        .filter(
          (tn) => tn.name.toLocaleLowerCase().includes(value.toLocaleLowerCase()) && tn.__typename === 'Directory',
        )
        .map((directory) => directory.id);
      if (directories.length > 0) {
        // First get properties within the directory
        const properties = await this.findPropertiesInDirectory(directories);
        this.directoryProperties = properties?.treeNodes.items.map((property) => property.id) ?? [];
      }
    },
    selectedHeatingSystemType() {
      this.nodes = this.filteredTreeNodes;
    },
    selectedCustomerId: {
      immediate: true,
      async handler(customerId) {
        if (customerId) {
          this.alertCounts = await this.fetchAlertsForCustomer(customerId);
        }
      },
    },
  },
  async mounted() {
    this.nodes = this.filteredTreeNodes;
    for (const [id, items] of this.directoryHeatingSystemMap) {
      this.treeNodeHeatingSystems.push({
        treeNodeId: id,
        heatingSystems: items.length > 0 ? items : [],
      });
    }
  },
  created() {
    if (this.contextMenuOptions.length > 0) {
      this.summaryModalTab = this.contextMenuOptions[0].action;
    }
  },
  methods: {
    getSubColumns(component: ComponentGroup): SubColumn[] {
      return this.subColumnsByGroupName[component.groupName] ?? [{ label: 'VL' }, { label: 'RL' }];
    },

    isPufferspeicher,

    isWarmwasseraufbereitung,

    getColspanByComp(groupName: string): number {
      if (this.isPufferspeicher(groupName)) {
        const labels = this.pufferspeicherLabelsByGroupName[groupName];
        return Array.isArray(labels) && labels.length > 0 ? labels.length : 2;
      }

      if (this.isWarmwasseraufbereitung(groupName)) {
        const labels = this.warmwasseraufbereitungLabelsByGroupName[groupName];
        return Array.isArray(labels) && labels.length > 0 ? labels.length : 2;
      }

      return 2;
    },

    getMetricValueFromGroupAndMetricName(
      chosenGroup: HeatingSystem['heatingSystemMeasurementGroups'][number] | null,
      metricName: string | null,
    ): string {
      if (!chosenGroup || !metricName) return '-';

      const spotId = chosenGroup?.spotId ?? chosenGroup?.heatingSystemMeasurements?.[0]?.spotId;
      if (!spotId) return '-';

      const spot = this.spots.find((spot) => spot.id === spotId);
      if (!spot) return '-';

      const metric = spot.metricsLatest.find((m) => m.__typename === 'ContinuousMetric' && m.name === metricName);

      if (!metric || metric.__typename !== 'ContinuousMetric') return '-';
      return formatMetricValue(Number(metric.latest.value).toFixed(2));
    },

    getMetricValueForComponentLabel<TLabel extends string>(
      hs: HeatingSystem,
      label: TLabel,
      groupName: string,
      pickGroup: (
        groups: HeatingSystem['heatingSystemMeasurementGroups'],
        label: TLabel,
      ) => HeatingSystem['heatingSystemMeasurementGroups'][number] | null,
      resolveMetricName: (measurements: MeasurementRef[], label: TLabel) => string | null,
    ): string {
      const sameNameGroups = hs.heatingSystemMeasurementGroups.filter((group) => group.groupName === groupName);
      const chosenGroup = pickGroup(sameNameGroups, label);

      const measurements = chosenGroup?.heatingSystemMeasurements ?? [];
      const metricName = resolveMetricName(measurements, label);

      return this.getMetricValueFromGroupAndMetricName(chosenGroup, metricName);
    },

    getMetricValueForComponentLabelPos(
      hs: HeatingSystem,
      labelPos: OtherComponentLabelPos,
      groupName: string,
      pickGroup: (
        groups: HeatingSystem['heatingSystemMeasurementGroups'],
        labelPos: OtherComponentLabelPos,
      ) => HeatingSystem['heatingSystemMeasurementGroups'][number] | null,
    ): string {
      const sameNameGroups = hs.heatingSystemMeasurementGroups.filter((group) => group.groupName === groupName);
      const chosenGroup = pickGroup(sameNameGroups, labelPos);

      const measurements = chosenGroup?.heatingSystemMeasurements ?? [];
      const metricName = metricNameForLabelPos(measurements, labelPos);

      return this.getMetricValueFromGroupAndMetricName(chosenGroup, metricName);
    },
    isOpen(e: number) {
      this.nodes[e].isOpen = !this.nodes[e].isOpen;
    },
    async findPropertiesInDirectory(ids: string[]) {
      try {
        const { data } = await this.$apollo.query<DirectoryPropertiesQuery>({
          query: propertiesInDirectoryQuery,
          variables: {
            ids,
          },
          fetchPolicy: 'no-cache',
        });
        return data;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
    getHeatingSystems(treeNode: TreeNode): HeatingSystem[] {
      let heatingSystems = this.directoryHeatingSystemMap.get(treeNode.id) ?? [];
      heatingSystems = filterHeatingSystemsByType(heatingSystems, this.selectedHeatingSystemType);

      if (this.advancedViewSearchQuery) {
        const matchedHeatingSystems: HeatingSystemCollectionWithPaginationQuery_heatingSystemsList_items[] = [];
        const searchQuery = String(this.advancedViewSearchQuery).trim().toLocaleLowerCase();
        // First, check the type of the searchQuery treeNode ID
        const directories = this.treeNodes
          .filter((tn) => tn?.name.toLocaleLowerCase().includes(searchQuery) && tn.__typename === 'Directory')
          .map((tn) => tn.id);
        if (directories.length > 0) {
          // Filter using properties inside the directory
          const properties = this.directoryProperties;
          // First get properties within the directory
          matchedHeatingSystems.push(
            ...heatingSystems.filter((hs) => properties.some((property) => hs.siteId === property)),
          );
        }
        // As some properties might match the search query, we need to filter the heating systems again
        heatingSystems = [
          ...matchedHeatingSystems,
          ...heatingSystems.filter((hs) => hs.name.toLocaleLowerCase().includes(searchQuery)),
        ];
      }

      // Remove any duplicates
      return heatingSystems
        .filter((value, index, self) => self.indexOf(value) === index)
        .sort((a, b) => a.name.localeCompare(b.name));
    },
    getMetricValueForPufferspeicherComponent(hs: HeatingSystem, label: PufferspeicherLabel, groupName: string): string {
      return this.getMetricValueForComponentLabel(
        hs,
        label,
        groupName,
        (groups, lbl) => findPufferspeicherGroupByLabel(groups, lbl),
        (measurements, lbl) => metricNameForPufferspeicherLabel(measurements, lbl),
      );
    },
    getMetricValueForWarmwasseraufbereitungComponent(
      hs: HeatingSystem,
      label: WarmwasseraufbereitungLabel,
      groupName: string,
    ): string {
      return this.getMetricValueForComponentLabel(
        hs,
        label,
        groupName,
        (groups, lbl) => findWarmwasseraufbereitungGroupByLabel(groups, lbl),
        (measurements, lbl) => metricNameForWarmwasseraufbereitungLabel(measurements, lbl),
      );
    },
    getMetricValueForHeatingControlComponent(hs: HeatingSystem, metricName: string, groupName: string): string {
      let value: string | number = '-';
      const heatingSystemMeasurementGroups = hs.heatingSystemMeasurementGroups.filter(
        (group) => group.groupName === groupName,
      );
      const spotId = heatingSystemMeasurementGroups[0]?.spotId;

      if (spotId) {
        const spot = this.spots.find((spot) => spot.id === spotId);

        if (spot) {
          //the metric will be directly available on the spot with the original metricName like 'Anfang_AT_0V' or 'Rückltemp_RüF11' etc.
          const directMetric = spot.metricsLatest.find(
            (metric) => metric.__typename === 'ContinuousMetric' && metric.name === metricName,
          );

          if (directMetric && directMetric.__typename === 'ContinuousMetric') {
            value = directMetric.latest.value;
          }
        }
      }

      return formatMetricValue(value);
    },
    getMetricValueForOtherComponents(hs: HeatingSystem, labelPos: OtherComponentLabelPos, groupName: string): string {
      return this.getMetricValueForComponentLabelPos(hs, labelPos, groupName, (groups, pos) =>
        pickMeasurementGroupForLabelPos(groups, pos, true),
      );
    },
    getSpotName(heatingSystem: HeatingSystem): string {
      const spotIds = heatingSystem.heatingSystemMeasurementGroups.flatMap((group) =>
        group.heatingSystemMeasurements.flatMap(({ spotId }) => spotId),
      );

      if (spotIds.length > 0) {
        return this.spots.find((spot) => spot.id === spotIds[0])?.activeDeviceMount?.modbusModel || '';
      }

      return '';
    },
    isHeatingControl(heatingSystem: HeatingSystem): boolean {
      return heatingSystem.heatingSystemMeasurementGroups.find(
        (group) =>
          group.systemComponentTypeName === 'HEATING_CONTROL' ||
          this.spots.some((spot) => spot.id === group?.spotId && spot.role === 'HEATING_CONTROL'),
      )
        ? true
        : false;
    },
    openGraphModal(hs: HeatingSystem) {
      this.selectedHeatingSystem = hs;
      this.selectedSpotId = this.spotId;

      this.$store.commit('setSelectedGraphObject', hs);
      this.$store.commit('showAdvancedViewGraph', true);
    },
    goToRegisters(hs: HeatingSystem) {
      this.$router.push({ name: 'AppHeatingSystem/EditRegisters', params: { treeNodeId: hs.siteId } });
    },
    handleContextMenu(event: MouseEvent, hs: HeatingSystem, treeNode: TreeNode) {
      event.preventDefault();
      this.showContextMenu = true;
      this.contextMenuHeatingSystem = hs;
      this.selectedSpotId = this.spotId;
      this.contextMenuTreeNodeId = treeNode.id;

      let top = event.clientY;
      let left = event.clientX;

      this.$nextTick(() => {
        const menu = document.querySelector('.context-menu') as HTMLElement;
        if (menu) {
          const { innerWidth, innerHeight } = window;
          const rect = menu.getBoundingClientRect();

          if (left + rect.width > innerWidth) {
            left = innerWidth - rect.width - 20;
          }
          if (top + rect.height > innerHeight) {
            top = innerHeight - rect.height - 20;
          }
          left = Math.max(8, left);
          top = Math.max(8, top);

          this.contextMenuStyle = {
            top: `${top}px`,
            left: `${left}px`,
          };
        }
      });

      document.addEventListener('click', this.hideContextMenu);
    },
    hideContextMenu() {
      this.showContextMenu = false;
      this.contextMenuHeatingSystem = null;
      document.removeEventListener('click', this.hideContextMenu);
    },
    handleContextMenuAction(action: string) {
      if (!this.contextMenuHeatingSystem) return;

      this.summaryModalTab = action;
      this.summaryModalHeatingSystem = this.contextMenuHeatingSystem;
      this.showSummaryModal = true;
      this.hideContextMenu();
    },
    openSummaryModalToTab(hs: HeatingSystem, tab: string) {
      // open summary modal to particular tab
      this.contextMenuHeatingSystem = hs;
      this.handleContextMenuAction(tab);
    },
    showRow(hs: HeatingSystem): boolean {
      if (this.selectedHeatingSystemType === HeatingSystemType.Kessel) {
        return hs.heatingSystemMeasurementGroups.some(
          (group) => group.systemComponentTypeName === HEATING_SYSTEM_COMPONENT_TYPE_FILTERS.BOILER,
        );
      } else if (this.selectedHeatingSystemType === HeatingSystemType.Fernwärme) {
        return hs.heatingSystemMeasurementGroups.some(
          (group) =>
            group.systemComponentTypeName === HEATING_SYSTEM_COMPONENT_TYPE_FILTERS.TELE_HEATING ||
            group.systemComponentTypeName === HEATING_SYSTEM_COMPONENT_TYPE_FILTERS.TELE_HEATING_SECONDARY ||
            group.systemComponentTypeName === HEATING_SYSTEM_COMPONENT_TYPE_FILTERS.HEATING_CONTROL,
        );
      } else if (this.selectedHeatingSystemType === HeatingSystemType.BHKW) {
        return hs.heatingSystemMeasurementGroups.some(
          (group) => group.systemComponentTypeName === HEATING_SYSTEM_COMPONENT_TYPE_FILTERS.COMBINED_HEAT_POWER_PLANT,
        );
      } else if (this.selectedHeatingSystemType === HeatingSystemType.Wärmepumpe) {
        return hs.heatingSystemMeasurementGroups.some(
          (group) =>
            group.systemComponentTypeName === HEATING_SYSTEM_COMPONENT_TYPE_FILTERS.HEAT_PUMP_PRIMARY ||
            group.systemComponentTypeName === HEATING_SYSTEM_COMPONENT_TYPE_FILTERS.HEAT_PUMP_SECONDARY,
        );
      } else if (this.selectedHeatingSystemType === HeatingSystemType.Solarthermieanlage) {
        return hs.heatingSystemMeasurementGroups.some(
          (group) => group.systemComponentTypeName === HEATING_SYSTEM_COMPONENT_TYPE_FILTERS.SOLAR_HEATING,
        );
      }

      return true;
    },
    hasHeatingSystems(treeNode: TreeNode): boolean {
      return this.getHeatingSystems(treeNode).length > 0;
    },
    hsKey(hs: HeatingSystem): string {
      return hs.heatingSystemMeasurementGroups
        .map(
          (group) =>
            `${group.groupName}-${group.heatingSystemMeasurements.at(0)?.spotId}-${Math.random()
              .toString(36)
              .substring(2, 15)}`,
        )
        .join('');
    },
    faIconClass(icon: string) {
      switch (icon) {
        case 'graph':
          return 'fa-solid fa-chart-column';
        case 'bell':
          return 'fa-regular fa-bell';
        case 'temperature-high':
          return 'fa-solid fa-temperature-high';
        case 'exclamation-triangle':
          return 'fa-solid fa-triangle-exclamation';
        default:
          return 'fa-solid fa-question';
      }
    },
    async fetchAlertsForCustomer(customerId: string): Promise<Record<string, number>> {
      try {
        const { data } = await this.$apollo.query({
          query: AlertTicketsByCustomerIdQuery,
          client: APOLLO_CLIENT.HEATING_SYSTEM_COLLECTOR_CLIENT,
          variables: { customerId },
          fetchPolicy: 'no-cache',
        });
        // Map alert counts by heatingSystemId, only for opened tickets
        if (data && data.findAllAlertTicketsByCustomerId) {
          return data.findAllAlertTicketsByCustomerId.reduce((acc: Record<string, number>, alert: any) => {
            if (alert.ticketStatus === TicketStatus.OPENED) {
              acc[alert.heatingSystemId] = (acc[alert.heatingSystemId] || 0) + 1;
            }
            return acc;
          }, {});
        }
        return {};
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to fetch alerts:', error);
        return {};
      }
    },
  },
});
